import { render, staticRenderFns } from "./advisoryBanner.vue?vue&type=template&id=fb0c8e3a&scoped=true&"
import script from "./advisoryBanner.vue?vue&type=script&lang=js&"
export * from "./advisoryBanner.vue?vue&type=script&lang=js&"
import style0 from "./advisoryBanner.vue?vue&type=style&index=0&id=fb0c8e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0c8e3a",
  null
  
)

export default component.exports